import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f081892"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "camera_list_tile" }
const _hoisted_2 = { class: "thumbnail_wrap" }
const _hoisted_3 = { class: "thumbnail_text" }

import Thumbnail from '@/components/atoms/Thumbnail.vue'
import { computed } from 'vue'
import { CameraDetail } from '@/@types/typescript-axios/api'

type PropsType = {
  cameraData: CameraDetail
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraListTile',
  props: {
    cameraData: null
  },
  setup(__props: any) {

const props = __props as {
  cameraData: CameraDetail
};



const linkParams = computed(() => ({
  name: 'detail',
  params: { code: props.cameraData.camera_code },
}))

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: _unref(linkParams) }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Thumbnail, {
            src: __props.cameraData.thumb_url,
            width: "100%"
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.cameraData.camera_name), 1)
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})